import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

// The listing lives at /creator/library; this layout hosts the wizard and editor.
export const Route = createFileRoute('/_authenticated/_creator/_content/creator/content')({
  component: () => <Outlet />,
  beforeLoad: ({ location }) => {
    if (location.pathname.replace(/\/$/, '') === '/creator/content') {
      throw redirect({ to: '/creator/library' });
    }
  },
});
